import { provide as t } from "vue";
const n = /* @__PURE__ */ Symbol("elForwardRef"), d = (e) => {
  t(n, {
    setForwardRef: ((r) => {
      e.value = r;
    })
  });
}, s = (e) => ({
  mounted(o) {
    e(o);
  },
  updated(o) {
    e(o);
  },
  unmounted() {
    e(null);
  }
});
export {
  n as FORWARD_REF_INJECTION_KEY,
  d as useForwardRef,
  s as useForwardRefDirective
};
